import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";

const TermsofService = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Terms of Service" />
			<section className="services-pages pt-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<p class="primary-regular-font extra-color-5 level-7 mt-3">
								Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
								tempor, augue sit amet condimentum euismod, tellus tellus
								pharetra massa, id aliquet eros mi at leo. Nunc vitae mi in arcu
								malesuada mollis. Quisque et porttitor est. Integer iaculis dui
								tellus, vitae pretium metus iaculis in. Cras faucibus vel dui eu
								placerat. Sed ultricies, massa in sodales volutpat, augue tortor
								varius turpis, tincidunt luctus tellus augue ultrices sem. Fusce
								suscipit ultrices justo quis tempus. Suspendisse mattis lorem
								quis diam vehicula, et vehicula felis condimentum. Nullam at
								lorem quis erat efficitur lobortis. Integer cursus elit sit amet
								est euismod interdum. Nam venenatis nisl non mauris porta
								sollicitudin. Praesent et ex libero. Lorem ipsum dolor sit amet,
								consectetur adipiscing elit.
								<br /> <br />
								Vivamus pulvinar quis velit at tempus. Nam pretium sed nisi id
								aliquet. Mauris sed congue purus. Integer ut suscipit ante.
								Praesent maximus accumsan neque. In nec enim in justo faucibus
								sagittis. Cras nisl sapien, finibus ac sem vel, pellentesque
								pretium augue. Sed et enim id neque condimentum ullamcorper.
								Quisque eu aliquam tortor. Nam a gravida mauris, mollis aliquet
								quam. Maecenas tristique placerat ligula. Morbi iaculis eros
								velit, et imperdiet massa tristique non. Etiam elementum aliquam
								tellus, cursus porta orci condimentum id. Vivamus maximus velit
								at dolor feugiat, finibus interdum ex gravida. In a tellus eget
								nunc gravida iaculis.
								<br /> <br />
								Praesent semper leo odio, in aliquam mi pellentesque eu. Aliquam
								dictum, sapien ut ultrices aliquam, massa enim tristique tortor,
								sed maximus lorem dolor dictum nunc. Aliquam sodales elementum
								libero quis convallis. Curabitur lacinia at tellus id convallis.
								Suspendisse potenti. Nunc auctor metus at libero tincidunt
								hendrerit. Nulla facilisi.
								<br /> <br />
								Suspendisse scelerisque facilisis urna a viverra. Integer
								suscipit rutrum fermentum. Phasellus varius posuere velit, vel
								tempus orci porttitor malesuada. Praesent et eros aliquet,
								tempus erat et, bibendum odio. Pellentesque tristique fermentum
								eros sit amet lobortis. Vestibulum ante ipsum primis in faucibus
								orci luctus et ultrices posuere cubilia curae; Vestibulum
								dapibus maximus erat, suscipit efficitur erat vestibulum id.
								Aenean pharetra ornare elit id pellentesque.
								<br /> <br />
								Etiam consectetur sed arcu quis dignissim. Aenean suscipit ipsum
								fringilla metus dictum viverra. Fusce ac quam fringilla, commodo
								dolor non, luctus leo. Pellentesque vel magna sed mauris
								ultrices cursus in scelerisque magna. Nullam tellus nibh, porta
								et molestie eu, congue sit amet turpis. Nunc facilisis tempor
								turpis quis feugiat. Ut egestas libero ut nibh aliquam, a
								blandit purus facilisis. Sed ac sem sed velit imperdiet pharetra
								non sed dolor. Maecenas eros odio, dignissim nec magna mollis,
								maximus placerat urna.
								<br /> <br />
								In vulputate quis arcu eget pharetra. Cras egestas rutrum
								pellentesque. Etiam quis ultricies turpis. Praesent dapibus
								dignissim lacus. Etiam tristique tempus quam malesuada
								malesuada. Aenean auctor, ante vitae vulputate laoreet, lectus
								urna semper nulla, vel elementum ipsum nunc eu elit. Etiam
								cursus egestas urna a vestibulum. Mauris lobortis tellus
								faucibus urna vulputate, ac dictum ex lobortis. Integer sit amet
								velit ipsum. Maecenas rhoncus condimentum odio, sit amet semper
								odio varius at. In aliquam imperdiet nunc, at convallis ante
								sodales ut. Curabitur non placerat velit. Etiam commodo pulvinar
								enim sed placerat. Donec vestibulum euismod nisl ac fermentum.
								Sed vel lobortis velit.
								<br /> <br />
								Donec egestas odio id viverra dapibus. Curabitur quam massa,
								facilisis at ipsum eget, consequat lobortis dui. Nam gravida
								urna id nibh rhoncus efficitur. Suspendisse vehicula, nisl sed
								congue tincidunt, nisl velit tempor magna, sit amet facilisis
								mauris ante a felis. Morbi pharetra diam in lectus faucibus
								efficitur. Donec viverra ipsum eu lectus posuere, sit amet
								accumsan nisl porttitor. Nulla fringilla elementum massa, id
								laoreet dui consequat ac. Phasellus pretium eros at quam
								pellentesque tincidunt. Orci varius natoque penatibus et magnis
								dis parturient montes, nascetur ridiculus mus. Donec odio nunc,
								fermentum ut augue a, congue porta elit. Aenean id mauris vitae
								dolor mattis viverra. Mauris metus leo, elementum elementum quam
								sed, porta ornare leo. Integer condimentum, dolor eu dapibus
								vehicula, quam tellus fermentum neque, at interdum quam neque eu
								nunc.
							</p>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default TermsofService;
